import React, { useEffect, useState, useRef} from 'react'
import { Card, Table, Tooltip, Space } from 'antd';
import AddEmployeeDesignations from './AddEmployeeDeisgnation';
import IconButton from 'components/ui/Button/IconButton';
import { ImagePaths } from "utils/ImagePath";
import MasterFilter from "pages/master/MasterFilter";
import CommonTblHeader from "components/common/CommonTblHeader";
import ToastMsg from "components/common/ToastMsg";
import { EMPLOYEE_DESIGNATION } from 'constants';
import { checkUserPermissionFunc } from "components/common/CommonFuntion";
import { CommonDeletePopup } from 'components/common/CommonComponent';
import useApiMethods from 'hooks/apiConfig/method/apiMethods';
import { NEW_EMPLOYEE_DESIGNATION } from 'constant';

const initialData = {
  designation_code: "",
  designation_name: "",
  designation_is_active: "",
}

function EmployeeDesignation() {
  let query = "";
  let queryRef = useRef("");
  const pageSize = 10;
  const [addVisible, setAddVisible] = useState(false);
  const [editVisible, setEditVisible] = useState(false);
  const [selectedDetails, setSelectedDetails] = useState({});
  const [searchText, setSearchText] = useState("");
  const [dataUpdated, setDataUpdated] = useState(false);
  const authtoken = sessionStorage.getItem("token")
  const [pageNo, setPageNo] = useState(1);
  const [sorting, setSorting] = useState("");
  const [filterVisible, setFilterVisible] = useState(false);
  const [filterDatas, setFilterDatas] = useState({ initialData });
  const [reorderedColumns, setReorderedColumns] = useState([]);
  const [isDraft, setIsDraft] = useState(false);
  const [deleteItem, setDeleteClicked] = useState({ id: undefined, isDeleteClicked: false });
  const tableContainerHeight = (addVisible || editVisible) ? "64vh" : isDraft ? "77.5vh" : "72vh";

  const queryString =
  "code=" + (filterDatas.designation_code ? filterDatas.designation_code : "") +
  "&designation_name=" + (filterDatas.designation_name ? filterDatas.designation_name : "") +
  "&active_status=" + (filterDatas.designation_is_active !== undefined ? filterDatas.designation_is_active : "") +
  "&search=" + searchText + (sorting ? `&${sorting}` : "");


  // const [data, pageInfo, loading, _message, refetch] = useApiData(getEmployeeDesignationPagination, {
  //   pageNo,
  //   pageSize,
  //   queryString,
  //   searchText,
  //   sorting
  // });

  // useEffect(() => {
  //   if (_message && _message.isErrorMsg && _message.errorMsgText) {
  //     ToastMsg('error', _message.errorMsgText);
  //   }
  // }, [_message.errorMsgText]);

  const { fetch, update } = useApiMethods();
  const [data, setData] = useState([]);
  const [pageInfo, setPageInfo] = useState([])
  const [loading, setLoading] = useState(false);
  const [filter, setFilter] = useState({ pageNo: '', pageSize: '', query: '', search: '', sorting: '' })

  const fetchEmpDesignationData = async () => {
    const response = await fetch(NEW_EMPLOYEE_DESIGNATION, filter, setLoading);
    if (response?.status) {
      setData(response?.data?.result);
      setPageInfo({
        pageNo: response.data.page_no,
        pageSize: response.data.page_size,
        totalCount: response.data.total_count,
        noOfPages: response.data.no_of_pages,
      });
    }
  };

  useEffect(() => {
    if (!authtoken) {
      window.location.href = '/';
    }
    fetchEmpDesignationData();
  }, [filter, authtoken, editVisible == true]);

  const userPermission = checkUserPermissionFunc("master", "Designation", "SubMenu");

  const addClick = () => {
    setAddVisible(true);
    setEditVisible(false);
    setSelectedDetails({});
  };

  const handleEditClick = (details) => {
    if (editVisible && Object.keys(selectedDetails).length > 0) {
      ToastMsg("warning", "Please cancel the existing edit operation!")
    }
    else if (!editVisible) {
      setEditVisible(true);
      setSelectedDetails(details);
      setAddVisible(false);
    }
  };

  const handleSave = () => {
    setEditVisible(false);
    setAddVisible(false);
    setSelectedDetails({});
    setIsDraft(false);
    setFilter(pageNo,
      pageSize,
      query,
      searchText,
      sorting);
    setDataUpdated(!dataUpdated);
  };

  const handleCancel = () => {
    setEditVisible(false);
    setAddVisible(false);
    setSelectedDetails({});
    setDataUpdated(!dataUpdated);
  };

  const handleSearch = () => {
    setEditVisible(false)
    setAddVisible(false)
    setSelectedDetails({});
    setPageNo(1);
    setFilter((prevFilter) => ({
      ...prevFilter,
      pageNo: 1,
      pageSize: pageSize || prevFilter.pageSize,
      query: queryString,
      search: searchText,
      sorting: sorting,
    }));
    setDataUpdated(!dataUpdated);
  }

  const handleTableChange = (pagination, filters, sorter) => {
    const sortorder = `sort=${sorter.order === "descend" ? "desc" : sorter.order === "ascend" ? "asc" : ""}&`
    const sortQuery = sorter.order ? `${sortorder}column=${sorter.columnKey}` : "";
    queryRef.current = isDraft ? `is_draft=True` : "";
    setFilter((prevFilter) => ({
      ...prevFilter,
      pageNo: pagination.current,
      pageSize: pagination.pageSize || prevFilter.pageSize,
      query: isDraft ? `is_draft=True` : queryString,
      sorting: sortQuery,
    }));
    setSorting(sortQuery)
  }

  const columns = [
    {
      title: "Designation Code",
      dataIndex: "code",
      key: "code",
      sorter: true,
      width: "24.7%",
      fixed: "left",
      render: (_, record) =>
      (record?.code?.length > 20 ?
        <Tooltip title={record?.code}>{<span style={{ color: record?.is_active ? "black" : "#CACACA" }}>{record?.code?.slice(0, 20) + "..."}</span>}</Tooltip>
        : <p style={{ color: record?.is_active ? "black" : "#CACACA" }}>{record?.code ? record?.code : "-"}</p>),
    },
    {
      title: "Designation Name",
      dataIndex: "designation_name",
      key: "designation_name",
      sorter: true,
      width: "24.7%",
      fixed: "left",
      render: (_, record) =>
      (record?.designation_name?.length > 35 ?
        <Tooltip title={record?.designation_name}>{<span style={{ color: record?.is_active ? "black" : "#CACACA" }}>{record?.designation_name?.slice(0, 35) + "..."}</span>}</Tooltip>
        : <p style={{ color: record?.is_active ? "black" : "#CACACA" }}>{record?.designation_name ? record?.designation_name : "-"}</p>),
    },
    {
      title: "Notes",
      key: "notes",
      dataIndex: "notes",
      width: "23.75%",
      fixed: "left",
      sorter: true,
      fixed: 'left',
      render: (_, record) =>
      (record?.notes?.length > 34 ?
        <Tooltip title={record?.notes}>{<span style={{ color: record?.is_active ? "black" : "#CACACA" }}>{record?.notes?.slice(0, 34) + "..."}</span>}</Tooltip>
        : <p style={{ color: record?.is_active ? "black" : "#CACACA" }}>{record?.notes ? record?.notes : "-"}</p>),
    },
    {
      title: "Status",
      key: "is_active",
      dataIndex: "is_active",
      sorter: true,
      width: "16.25%",
      render: (_, record) =>
        record.is_active === true ? (
          <span style={{ color: "black" }}>Active</span>
        ) : (
          <span style={{ color: "#CACACA" }}>Inactive</span>
        ),
      align: 'center',
      fixed: "left",
    },
  ];

  if (userPermission?.edit) {
    columns.push({
      title: "Action",
      key: "action",
      align: 'center',
      width: "10.6%",
      fixed: "left",
      render: (_, record) => (
        <div className="flex justify-center items-center">
          <Space size={"middle"}>
            <IconButton
              title="Edit"
              icon={<img src={ImagePaths.edit.default} alt="Edit" />}
              onClick={() => (loading ? "" : handleEditClick(record))}
              testID={'ug_btn_edit'}
            />
            {record.is_draft === true ?
              <IconButton
                title="Delete"
                icon={<img src={ImagePaths.delete.default} alt="Delete" />}
                onClick={() => (loading ? "" : handleDeleteClicked(record?.id))}
                testID={'ug_btn_delete'}
              /> : null}
          </Space>
        </div>
      ),
    },)
  }

  //draf delete start
  const handleDeleteClicked = (id) => {
    setDeleteClicked((prevdata) => ({
      ...prevdata,
      id: id,
      isDeleteClicked: true
    }));
  }

  const handleCancelBtn = () => {
    setDeleteClicked((prevdata) => ({
      ...prevdata,
      id: undefined,
      isDeleteClicked: false
    }));
  }

  const handleDeleteBtn = async (id) => {
    try {
      const formData = {
        "id": id,
        "is_active": false,
        "draft_delete": true,
        "is_draft": true,
      }

      const response = await update(NEW_EMPLOYEE_DESIGNATION, formData);

      if (response?.status) {
        ToastMsg("success", response?.message);
        handleDraft();
        setDeleteClicked((prevdata) => ({
          ...prevdata,
          isDeleteClicked: false
        }));
      } else {
        ToastMsg("error", response?.message || "Failed to delete the employee designation.");
      }
    } catch (error) {
      console.log(error);
    } finally {
      handleCancelBtn();
    }
  }//draf delete end

  // filter start
  const renderFilter = (data) => {
    setFilterDatas((prevdata) => ({ ...prevdata, ...data }));
    setPageNo(1);
    setFilter((prevFilter) => ({
      ...prevFilter,
      pageNo: 1,
      pageSize: pageSize || prevFilter?.pageSize,
      query: `code=${data.designation_code ? data.designation_code : ""}&designation_name=${data.designation_name ? data.designation_name : ""}&active_status=${data.designation_is_active !== undefined ? data.designation_is_active : ""}`,
      search: searchText,
      sorting: sorting,
    }));
    setFilterVisible(false);
  }

  const ClosePopUp = () => {
    setFilterVisible(false);
  }

  const clearFilter = () => {
    setFilterDatas(initialData);
    setPageNo(1);
    setFilter(1,
      pageSize,
      query,
      searchText,
      sorting);
  }
  //filter end

  const showAddEdit = () => {
    return (
      <AddEmployeeDesignations
        editDetails={selectedDetails}
        onHide={handleCancel}
        onSave={handleSave}
        fromEdit={editVisible}
        isActive = {userPermission?.active !== undefined ? userPermission?.active : true}
      />
    )
  }

  const handleFilter = () => {
    setFilterVisible(true)
  }

  const handleDraft = () => {
    setIsDraft(true);
    setFilterVisible(false);
    setSorting("");
    setPageNo(1);
    queryRef.current = `is_draft=True`
    setFilter((prev) => ({
      ...prev,
      pageNo: 1,
      sorting: "",
      query: queryRef.current,
      search: searchText
    }));
  }

  const handleBackToHome = () => {
    setIsDraft(false);
    setSorting("");
    setPageNo(1);
    queryRef.current = "";
    setFilter((prev) => ({
      ...prev,
      pageNo: 1,
      sorting: "",
      query: "",
      search: searchText
    }));
    setFilterDatas({initialData})
  }

  const handleStateChanges = (search = "", reorderedList = []) => {
    setSearchText(search)
    setReorderedColumns(reorderedList)
  }

  const printdata =
    "?page_no=" + pageNo +
    "&page_size=" + pageSize +
    "&code=" + (filterDatas.designation_code ? filterDatas.designation_code : "") +
    "&designation_name=" + (filterDatas.designation_name ? filterDatas.designation_name : "") +
    "&active_status=" + (filterDatas.designation_is_active !== undefined ? filterDatas.designation_is_active : "") +
    "&search=" + searchText + (sorting ? `&${sorting}` : "");

  const styles = {
    fltContainer: {
      border: "1px solid #cbcbcb",
      height: tableContainerHeight,
    },
  }

  return (
    <Card className="h-full overflow-hidden">
      <div className={"h-1/6"}>
        <CommonTblHeader pageName={"Designation"}
          addVisible={addVisible} editVisible={editVisible} addComponent={showAddEdit}
          pageInfo={pageInfo} handleSearch={handleSearch} selectedDetails={selectedDetails}
          addClick={addClick} onStateChange={handleStateChanges} handleFilter={handleFilter} columns={columns}
          handleDraft={handleDraft} isDraft={isDraft} handleBackToHome={handleBackToHome}
          url={NEW_EMPLOYEE_DESIGNATION} query={printdata}
          isAddRequired = {userPermission?.add ? true : false}
          isDraftRequired = {userPermission?.draft ? true : false}
        />
      </div>
      <div className="h-5/6 flex justify-center items-center mt-1">
        {filterVisible ?
          <div className="w-1/4 mt-5" style={styles.fltContainer}>
            <MasterFilter
              pageName={"Designation"}
              filterDatas={filterDatas}
              closeFilter={ClosePopUp}
              filteredData={renderFilter}
              clearData={clearFilter} />
          </div>
          : null}
        <div className={filterVisible ? "mt-5 w-3/4" : "mt-5 w-full"} style={styles.fltContainer}>
        <Table 
          columns={reorderedColumns?.length > 0 ? reorderedColumns : columns}
          dataSource={data?.length > 0 ? data : null}
          loading={loading}
          style = {{"--table-container-height": tableContainerHeight}}
          scroll={{ y: `calc(${tableContainerHeight} - 140px)` }}
          onChange={handleTableChange}
          pagination={{
            style: { marginRight: 20, padding: 0 },
            defaultPageSize: pageSize,
            showSizeChanger: false,
            showQuickJumper: true,
            total: pageInfo?.totalCount ? pageInfo?.totalCount : 0,
            pageSizeOptions: ["10", "20", "30"],
            pageSize,
            defaultCurrent: pageNo,
          }}
          key={isDraft ? (dataUpdated ? "draftUpdated" : "draftNotUpdated") : (dataUpdated ? "updated" : "not-updated")}
        />
        </div>
      </div>
      {deleteItem.isDeleteClicked ? <CommonDeletePopup handleCancelBtn={handleCancelBtn} handleDeleteBtn={() => handleDeleteBtn(deleteItem.id)} /> : null}
    </Card>
  );
}

export default EmployeeDesignation
